import React from 'react';

import { Disclosure } from '@headlessui/react';
import { clsx } from 'clsx';

import { PlusIcon } from '../../../components/svg/PlusIcon';
import QuestionIcon from '../../../components/svg/QuestionIcon.svg';

export const Accordion = ({
  title,
  className,
  children,
}: {
  title: string;
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={clsx(
        'mb-l cursor-pointer rounded-xs border border-secondary-80 bg-secondary-97 px-s pb-0 pt-r shadow-black-s',
        className,
      )}
    >
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="mb-r flex w-full cursor-pointer items-center justify-between border-none bg-transparent p-0 text-left text-s font-med text-structure-20">
              <span className="flex items-center gap-s">
                <img
                  src={QuestionIcon}
                  className="h-[20px] w-[20px]"
                  alt="Question icon"
                />
                <span>{title}</span>
              </span>
              <PlusIcon
                className={clsx(
                  'mr-xs transition-transform duration-200 ease-in [&_path]:fill-primary-40',
                  { 'rotate-45': open },
                )}
              />
            </Disclosure.Button>
            <Disclosure.Panel className="mb-r font-reg">
              {children}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
};
